<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/15uxLn/tc-custom/9781504071895.jpg?1737673517081" alt="This image is the cover for the book Searching for Sylvia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Searching for Sylvia
      </h1>
      <p class="bookDescription body article font2">
        <b>In this family saga full of mystery by the author of <i>The Doll Collector</i>, an Australian outback resort holds a secret that is about to be revealed.</b><br/><br/>Tordorrach is 70,000 acres of drought-stricken land in the Australian outback. Why do a group of wealthy people from London want to buy it?<br/><br/>Seamus, the owner of Tordorrach, lives in poverty. His homestead is derelict, and he is heavily in debt. The new owners run Outback Experience holidays on Tordorrach. Seamus becomes one of the gardeners, and he and his wife Mary move to a comfortable cabin on the property. Why does he hate the new owners so much that he plans to murder one of them?<br/><br/>The idyllic life of the new owners is shattered when the body of a woman is found buried on Tordorrach. Forensics find a bullet in her body. Who was she? And who murdered her?<br/><br/><b><i>Searching For Sylvia</i> is an unmissable mystery packed with suspense and will appeal to fans of authors like Linda Green, Dinah Jefferies and Linda Huber.</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joanna Stephen-Ward
      </h2>
      
      <p class="authorDescription body article">Joanna Stephen-Ward was born in the Australian outback, and grew up in Melbourne. Her school days were spent dreaming about being an opera singer or a writer. To the exasperation of her parents and teachers she spent her final year sitting at the back of the classroom writing a novel set in WW2.  When she left school she went to an opera school where she was taught drama, movement and language pronunciation and had small roles in the workshop productions. She was not good enough to become a professional opera singer, but the seeds of her novel Vissi d'arte were sown.  She left Australia and spent a year travelling around Europe and the UK. While working in outpatients for the NHS she met Peter and they married in 1985. They lived in Richmond Surrey and she worked at The National Archives, an enthralling place for anyone interested in history or crime.  Having been brought up as a lonely only child, she was astonished to discover in 2010 that she was one of eight children. She and her sister had last been together on a verandah in the outback when they were babies. They had a joyous reunion in Cornwall in 2012.  Joanna has written seven novels and is working on her eighth.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d788ce22